// Consumos.jsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Modal, Button, Form } from 'react-bootstrap';
import '../utils/Consumos.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPenToSquare} from '@fortawesome/free-solid-svg-icons';

const API_URL_CONSUMOS = process.env.REACT_APP_API_URL 
  ? `${process.env.REACT_APP_API_URL}/consumos`
  : 'http://localhost:4000/consumos';

  const API_URL_MEDIDORES = process.env.REACT_APP_API_URL 
  ? `${process.env.REACT_APP_API_URL}/medidores`
  : 'http://localhost:4000/medidores';

const API_URL_TARIFAS = process.env.REACT_APP_API_URL 
  ? `${process.env.REACT_APP_API_URL}/tarifas`
  : 'http://localhost:4000/tarifas';


const Consumos = () => {
  const [consumos, setConsumos] = useState([]);
  const [medidores, setMedidores] = useState([]);
  const [searchCode, setSearchCode] = useState('');
  const [selectedConsumo, setSelectedConsumo] = useState(null);
  const [medidorId, setMedidorId] = useState(null); // ID del medidor
  const [showModal, setShowModal] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [newConsumo, setNewConsumo] = useState({
    id_medidor: '',
    id_tarifa: '',
    lectura_anterior: 0,
    lectura_actual: '',
    fecha_lectura: '',
    reconexion: '',
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [cliente, setCliente] = useState(null);
  // Número de consumos por página
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const consumosPerPage = 10; // o el número que desees
// Filtrar consumos para la página actual

  const currentConsumos = consumos; 
  
useEffect(() => {
  fetchConsumos(currentPage);
}, [currentPage]);

  //HACE BUSQUEDAS AUTOMATICAS EN LA tabla
// Manejo de búsqueda
useEffect(() => {
  if (searchCode) {
    setCurrentPage(1); // Resetear a la primera página
    fetchConsumoByCode(searchCode);
  } else {
    fetchConsumos(1); // Cargar desde la página 1 nuevamente
  }
}, [searchCode]);

  const fetchConsumos = async (page = 1) => {
    try {
      const response = await axios.get(API_URL_CONSUMOS, {
        params: { page, limit: consumosPerPage }
      });
  
      setConsumos(response.data.consumos);
      setTotalPages(response.data.totalPages);
      setCurrentPage(page);
    } catch (error) {
      console.error('Error fetching consumos data:', error);
    }
  };
  
// Funciones de paginación corregidas
const nextPage = () => {
  if (currentPage < totalPages) {
    setCurrentPage(currentPage + 1);
  }
};

const prevPage = () => {
  if (currentPage > 1) {
    setCurrentPage(currentPage - 1);
  }
};

const handlePageChange = (page) => {
  if (page >= 1 && page <= totalPages) {
    setCurrentPage(page);
  }
};

  const fetchConsumoByCode = async (codigoMedidor) => {
    try {
      const response = await axios.get(`${API_URL_MEDIDORES}/consumos/${codigoMedidor}`);
      if (response.data) {
        setConsumos(response.data); // Actualiza los consumos con los resultados filtrados
        setTotalPages(1); // Asegurar que solo haya una página de resultados
      } else {
        setConsumos([]); // Vaciar la tabla si no se encuentran registros
        setTotalPages(1);
      }
    } catch (error) {
      console.error('Error fetching medidor data:', error.response || error.message);
      setConsumos([]); // Vaciar la tabla en caso de error
    }
  };  
  

const handleSearch = (e) => {
  e.preventDefault();
  if (searchCode) {
    fetchConsumoByCode(searchCode);
  } else {
    fetchConsumos();
  }
};

  const fetchClienteByMedidor = async (codigo_Medidor) => {
    try {
      const response = await axios.get(`${API_URL_MEDIDORES}/cliente-info/${codigo_Medidor}`);
      const data = response.data;
      console.log("Datos recibidos de la API:", data);
  
      if (data.error) {
        setErrorMessage('No se encontró el cliente para este código de medidor');
        setCliente(null);
      } else {
        setCliente(data);
        setErrorMessage('');
        
        // Actualizamos newConsumo con id_medidor y lectura_anterior
        setNewConsumo((prev) => ({
          ...prev,
          id_medidor: data.id_medidor,
          lectura_anterior: data.lectura_anterior, // Actualiza lectura anterior con el valor obtenido
        }));
      }
    } catch (error) {
      setErrorMessage('Medidor incorrecto o no existe');
      console.error(error);
      setCliente(null);
    }
  };

  const handleDelete = (consumo) => {
    console.log('Consumo seleccionado para eliminar:', consumo);
    setSelectedConsumo(consumo);
    setShowDeleteConfirm(true);
  };  
  
  const confirmDelete = async () => {
    if (!selectedConsumo || !selectedConsumo.id_consumo) {
      console.error('Error: El consumo seleccionado no es válido.');
      console.log(selectedConsumo);  // Para ver qué contiene selectedConsumo
      return;
    }
  
    try {
      await axios.delete(`${API_URL_CONSUMOS}/${selectedConsumo.id_consumo}`);
      fetchConsumos();
      setShowDeleteConfirm(false);
    } catch (error) {
      console.error('Error deleting consumo:', error);
    }
    setCurrentPage(1); // O página correspondiente
  };
  
  

  const cancelDelete = () => {
    setShowDeleteConfirm(false);
  };

  
  const handleAddConsumo = async (e) => {
    e.preventDefault();

    // Extraemos los valores de newConsumo
    const { id_medidor, lectura_anterior, lectura_actual, fecha_lectura, reconexion } = newConsumo;

    // Validación: asegurarse de que todos los campos estén completos
    if (!id_medidor || lectura_anterior === '' || !lectura_actual || !fecha_lectura) {
        setErrorMessage('Todos los campos son obligatorios.');
        return;
    }

    try {
        // Obtener el id_tarifa desde la API de tarifas
        const tarifaResponse = await axios.get(API_URL_TARIFAS);
        
        // Asignamos el id_tarifa, tomando el primer valor recibido
        const id_tarifa = tarifaResponse.data[0]?.id_tarifa;

        if (!id_tarifa) {
            setErrorMessage('No se pudo obtener el id_tarifa');
            return;
        }

        // Enviar la solicitud con todos los datos
        await axios.post(API_URL_CONSUMOS, { 
            id_medidor, 
            lectura_anterior, 
            lectura_actual, 
            fecha_lectura, 
            reconexion,
            id_tarifa // Se incluye el id_tarifa automáticamente
        });
        
        fetchConsumos(); // Actualiza los consumos
        handleCloseModal(); // Cierra el modal
    } catch (error) {
        console.error('Error adding consumo:', error);
        setErrorMessage('Ya existe un consumo en la fecha seleccionada, o la lectura actual no es correcta');
    }
    setCurrentPage(1);
};

  const handleOpenModal = () => {
    setNewConsumo({
      id_medidor: medidorId, // Asegúrate de que aquí esté el ID correcto
      lectura_anterior: '',
      lectura_actual: '',
      fecha_lectura: '',
      reconexion: '',
    });
    setShowModal(true);
  };
  

  const handleCloseModal = () => {
    setShowModal(false);
    setNewConsumo({
      id_medidor: medidorId, // Usar el ID del medidor que hemos guardado
      lectura_anterior: '',
      lectura_actual: '',
      fecha_lectura: '',
      reconexion: '',
    });
    setErrorMessage('');
    setCliente(null);
  };

  const handleOpenEditModal = (consumo) => {
    setSelectedConsumo(consumo);
    setShowEditModal(true); // Abre el modal para editar
  };  

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setSelectedConsumo(null);
  };

  const handleUpdateConsumo = async () => {
    try {
      const consumoActualizado = {
        id_medidor: selectedConsumo.id_medidor,  // Ahora debe estar presente
        lectura_anterior: selectedConsumo.lectura_anterior,
        lectura_actual: selectedConsumo.lectura_actual,
        fecha_lectura: selectedConsumo.fecha_lectura,
        reconexion: selectedConsumo.reconexion,
      };
  
      console.log("Datos enviados al backend:", consumoActualizado);
  
      //await axios.put(`http://localhost:4000/consumos/${selectedConsumo.id_consumo}`, consumoActualizado);
      await axios.put(`${API_URL_CONSUMOS}/${selectedConsumo.id_consumo}`, consumoActualizado);
      console.log("Consumo actualizado con éxito");
    } catch (error) {
      console.error("Error actualizando el consumo:", error);
    }
  };
  
  return (
    <div className="consumos-panel">
      <div className="header-buttons">
        <Button variant="primary" onClick={handleOpenModal}>+ Nuevo Consumo</Button>
      </div>
  
      <h2>Gestión de Consumos</h2>
  
      {/* Formulario de búsqueda */}
      <Form onSubmit={handleSearch} className="search-form">
        <Form.Control
          type="text"
          value={searchCode}
          onChange={(e) => setSearchCode(e.target.value)}
          placeholder="Buscar por código del medidor"
        />
        <Button variant="secondary" type="submit">Buscar</Button>
      </Form>
      <div className="consumos-panel1"> 
      
      {/* Paginación */}
      <div className="pagination-controls">
        <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
          Anterior
        </button>
        <span>{currentPage} de {totalPages}</span>
        <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
          Siguiente
        </button>
      </div>

      <table className="consumos-table">
        <thead>
          <tr>
            <th>Código del Medidor</th>
            <th>Lectura Anterior</th>
            <th>Lectura Actual</th>
            <th>Fecha de Lectura</th>
            <th>Reconexion</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {consumos.map((consumo) => (
            <tr key={consumo.id_consumo}>
              <td>{consumo.codigo_medidor} </td> 
              <td>{consumo.lectura_anterior}</td>
              <td>{consumo.lectura_actual}</td>
              <td>{new Date(consumo.fecha_lectura).toLocaleDateString()}</td>
              <td>{consumo.reconexion}</td>
              <td className="button-container">
                <Button variant="success" onClick={() => handleOpenEditModal(consumo)}><FontAwesomeIcon icon={faPenToSquare} /></Button>
                <Button variant="danger" onClick={() => handleDelete(consumo)}><FontAwesomeIcon icon={faTrash} /></Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      </div>
{/* Modal para agregar nuevo consumo */}
<Modal show={showModal} onHide={handleCloseModal}>
  <Modal.Header closeButton>
    <Modal.Title>Agregar Nuevo Consumo</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {errorMessage && <div className="alert alert-danger mt-3">{errorMessage}</div>}
    <Form onSubmit={handleAddConsumo}>
      <Form.Group>
        <Form.Label>Código de Medidor</Form.Label>
        <Form.Control
          type="text"
          value={newConsumo.codigo_medidor || ''}
          onChange={(e) => setNewConsumo({ ...newConsumo, codigo_medidor: e.target.value })}
          required
        />
      </Form.Group>
      <br />
      <Button variant="secondary" onClick={() => fetchClienteByMedidor(newConsumo.codigo_medidor)}>
        Buscar Cliente
      </Button>

      {cliente && (
        <div className="client-info mt-3">
          <h5>Cliente: {cliente.nombre_cliente}</h5>
        </div>
      )}

      <Form.Group>
        <br />
        <Form.Label>Fecha de Lectura</Form.Label>
        <Form.Control
          type="date"
          value={newConsumo.fecha_lectura || ''}
          onChange={(e) => setNewConsumo({ ...newConsumo, fecha_lectura: e.target.value })}
          required
        />
      </Form.Group>

      <Form.Group>
        <Form.Label>Lectura Anterior</Form.Label>
        <Form.Control
          type="number"
          value={newConsumo.lectura_anterior || ''} // Usa el valor actualizado aquí
          onChange={(e) => setNewConsumo({ ...newConsumo, lectura_anterior: e.target.value })}
          required
          disabled
        />
      </Form.Group>

      <Form.Group>
        <Form.Label>Lectura Actual</Form.Label>
        <Form.Control
          type="number"
          value={newConsumo.lectura_actual || ''}
          onChange={(e) => setNewConsumo({ ...newConsumo, lectura_actual: e.target.value })}
          required
        />
      </Form.Group>

      <Form.Group>
        <Form.Label>Reconexion</Form.Label>
        <Form.Control
          as="select"
          value={newConsumo.reconexion || ''}
          onChange={(e) => setNewConsumo({ ...newConsumo, reconexion: e.target.value })}
          required
        >
          <option value="">Seleccione el valor</option>
          <option value="SI">SI</option>
          <option value="NO">NO</option>
        </Form.Control>
      </Form.Group>

      <br />
      <Button variant="primary" type="submit">
        Agregar Consumo
      </Button>
    </Form>
  </Modal.Body>
</Modal>


      {/* Confirmación de eliminación */}
      <Modal show={showDeleteConfirm} onHide={cancelDelete}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Eliminación</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>¿Estás seguro de que deseas eliminar este consumo?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={cancelDelete}>Cancelar</Button>
          <Button variant="danger" onClick={confirmDelete}>Eliminar</Button>
        </Modal.Footer>
      </Modal>

      {/* Modal para editar consumo */}
      <Modal show={showEditModal} onHide={handleCloseEditModal}>
        <Modal.Header closeButton>
          <Modal.Title>Editar Consumo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {errorMessage && <div className="alert alert-danger mt-3">{errorMessage}</div>}
          <Form onSubmit={handleUpdateConsumo}>
          <Form.Group>
              <Form.Label>Fecha de Lectura</Form.Label>
              <Form.Control
                type="date"
                value={selectedConsumo?.fecha_lectura || ''}
                onChange={(e) => setSelectedConsumo({ ...selectedConsumo, fecha_lectura: e.target.value })}
                required
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Lectura Anterior</Form.Label>
              <Form.Control
                type="number"
                value={selectedConsumo?.lectura_anterior || ''}
                disabled // Deshabilitar el campo para que no sea editable
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Lectura Actual</Form.Label>
              <Form.Control
                type="number"
                value={selectedConsumo?.lectura_actual || ''}
                onChange={(e) => setSelectedConsumo({ ...selectedConsumo, lectura_actual: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Reconexion</Form.Label>
              <Form.Control
                as="select"
                value={selectedConsumo?.reconexion || ''}
                onChange={(e) => setSelectedConsumo({ ...selectedConsumo, reconexion: e.target.value })}
                required
              >
                <option value="">Seleccione el valor</option>
                <option value="SI">SI</option>
                <option value="NO">NO</option>
              </Form.Control>
            </Form.Group>
            <br />
            <Button variant="primary" type="submit">Actualizar</Button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Consumos;
